import { canonicalizeCountryCode } from "@/constants/billingCatalog"

const MARKET_BY_COUNTRY = {
  AG: "en", AU: "en", BB: "en", BS: "en", BW: "en", BZ: "en",
  BI: "en", CA: "en", CM: "en", DM: "en", FJ: "en", FM: "en",
  GB: "en", GD: "en", GH: "en", GM: "en", GY: "en", IE: "en",
  IN: "en", JM: "en", KE: "en", KI: "en", KN: "en", LC: "en",
  LR: "en", LS: "en", MH: "en", MT: "en", MW: "en", NA: "en",
  NG: "en", NR: "en", NZ: "en", PG: "en", PH: "en", PK: "en",
  PW: "en", RW: "en", SB: "en", SC: "en", SD: "en", SG: "en",
  SL: "en", SS: "en", SZ: "en", TO: "en", TT: "en", TV: "en",
  TZ: "en", UG: "en", US: "en", VC: "en", VU: "en", WS: "en",
  ZA: "en", ZM: "en", ZW: "en",
  AR: "es", BO: "es", CL: "es", CO: "es", CR: "es", CU: "es",
  DO: "es", EC: "es", ES: "es", GQ: "es", GT: "es", HN: "es",
  MX: "es", NI: "es", PA: "es", PE: "es", PY: "es", SV: "es",
  UY: "es", VE: "es",
}

export function landingMarket(country) {
  if (typeof country !== "string") return null
  return MARKET_BY_COUNTRY[country] ?? null
}

export function readLandingMarket(search) {
  const params = typeof search === "string" ? new URLSearchParams(search) : search
  const raw = params?.get?.("country")
  return landingMarket(canonicalizeCountryCode(raw))
}
